import { Action, createReducer, on } from '@ngrx/store';
import { BypassInformation, PigAccessory, PigAssociatedProduct, PigBulletin, PigComponent, PigQueryParams, pigQueryParamsFactory, PigQueryResult, ProductInformation, ReplacementPart } from '../../models';
import { LookupValue } from '../../models/lookup.model';

import * as fromActions from '../actions/pig.actions';


export const pigFeatureKey = 'pig';




export enum Loaders {
  loadLookups = 'Loading lookup values...',
  loadResults = "loadResults",
  loadingDetail = "loadingDetail",
  loadingDwg = 'loadingdwg'
}

export interface State {
  pigQueryParams?: PigQueryParams;
  pigQueryResults: PigQueryResult[];
  diameters: LookupValue[];
  efficiencies: LookupValue[];
  purposes: LookupValue[];
  services: LookupValue[];
  loaders: Loaders[];

  activatedPigId?: number;
  activePigProductInfo?: ProductInformation[];
  activePigBypassInfo?: BypassInformation[];
  activePigReplacementParts?: ReplacementPart[];
  activePigComponents?: PigComponent[];
  activePigAccessories?: PigAccessory[],
  activePigAssociatedProducts?: PigAssociatedProduct[],
  activePigBulletin?: PigBulletin[]
}

export const initialState: State = {
  diameters: [],
  efficiencies: [],
  purposes: [],
  services: [],
  pigQueryResults: [],
  loaders: [],
  pigQueryParams: pigQueryParamsFactory({})
};

export const reducer = createReducer(
  initialState,

  on(fromActions.loadPigLookups, (state, action) => ({
    ...state,
    loaders: state.loaders.concat(Loaders.loadLookups)
  })),
  on(fromActions.loadPigLookupsSuccess, (state, action) => ({
    ...state,
    diameters: action.data.diameters,
    efficiencies: action.data.pigEfficiencies,
    purposes: action.data.pigPurposes,
    services: action.data.pipelineServices,
    loaders: state.loaders.filter(f => f !== Loaders.loadLookups)
  })),
  on(fromActions.activatePig, (state, action) => ({
    ...state,
    activatedPigId: action.id,
    activePigBypassInfo: undefined,
    activePigProductInfo: undefined,
    activePigComponents: undefined,
    activePigAccessories: undefined,
    activePigAssociatedProducts: undefined,
    activePigBulletin: undefined,
  })),
  on(fromActions.loadPigQueryResults, (state, action) => ({
    ...state,
    loaders: state.loaders.concat(Loaders.loadResults),
    pigQueryResults: []
  })),
  on(fromActions.loadPigQueryResultsSuccess, (state, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadResults),
    pigQueryResults: action.results
  })),
  on(fromActions.loadPigQueryResultsFailure, (state, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadResults)
  })),
  on(fromActions.changePreviouslyPigged, (state, action) => ({
    ...state,
    pigQueryParams: {
      ...state.pigQueryParams,
      previouslyPigged: action.wasPreviouslyPigged
    }
  })),
  on(fromActions.changePipeSizeId, (state, action) => ({
    ...state,
    pigQueryParams: {
      ...state.pigQueryParams,
      pipeSizeId: action.pipeSizeId
    }
  })),
  on(fromActions.changePurposeId, (state, action) => ({
    ...state,
    pigQueryParams: {
      ...state.pigQueryParams,
      pigPurposeId: action.purposeId
    }
  })),
  on(fromActions.changeServiceId, (state, action) => ({
    ...state,
    pigQueryParams: {
      ...state.pigQueryParams,
      pipelineServiceId: action.serviceId
    }
  })),
  on(fromActions.changeBidirectional, (state, action) => ({
    ...state,
    pigQueryParams: {
      ...state.pigQueryParams,
      bidirectional: action.bidirectional
    }
  })),
  on(fromActions.changeEfficiency, (state, action) => ({
    ...state,
    pigQueryParams: {
      ...state.pigQueryParams,
      efficiencyEffectiveness: action.efficiency
    }
  })),
  on(fromActions.changeAggressiveness, (state, action) => ({
    ...state,
    pigQueryParams: {
      ...state.pigQueryParams,
      aggressivenessRisk: action.aggressiveness
    }
  })),
  on(fromActions.loadActivatedPigReferences, (state, action) => ({
    ...state,
    loaders: state.loaders.concat(Loaders.loadingDetail)
  })),
  on(fromActions.loadActivatedPigReferencesSuccess, (state, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadingDetail),
    activePigProductInfo: action.productInfo,
    activePigBypassInfo: action.bypassInfo,
    activePigReplacementParts: action.replacementParts,
    activePigComponents: action.components,
    activePigAccessories: action.accessories,
    activePigAssociatedProducts: action.associatedProducts,
    activePigBulletin: action.bulletin
  })),
  on(fromActions.loadActivatedPigReferencesFail, (state, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadingDetail)
  })),
  on(fromActions.loadActivePigCutSheet, (state, action) => ({
    ...state,
    loaders: state.loaders.concat(Loaders.loadingDwg)
  })),
  on(fromActions.loadActivePigCutSheetSuccess, (state, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadingDwg)
  })),
  on(fromActions.loadActivePigCutSheetFailure, (state, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadingDwg)
  }))
);
